import { useContext } from "react";

import { DimensionsContext, DimensionsProvider } from "./Dimensions";
import useWindowSizeEffect from "./useWindowSizeEffect";

type Props = {
  children: React.ReactNode;
};

export default function WindowDimensionsProvider({ children }: Props) {
  const { width } = useWindowSizeEffect();
  return <DimensionsProvider width={width}>{children}</DimensionsProvider>;
}

export const useWindowSize = () => useContext(DimensionsContext);
